import { useIsLocationAllowed } from "@/hooks/useIsLocationAllowed";
import mapSvg from "@/assets/maps.svg";
import { Button } from "@/components/ui/button";
import { useModal } from "@/hooks/useModal";

export function LocationModal() {
  const [, , , refreshLocation] = useIsLocationAllowed();
  const { closeModal } = useModal();

  return (
      <div className="bg-white rounded-3xl max-w-xs w-full mx-4 overflow-hidden shadow-lg">
        <div className="p-6 flex flex-col items-center">
        {/* biome-ignore lint/a11y/useAltText: <explanation> */}
        <img
            src={mapSvg}
            className='h-24'
            />
          
          {/* Text Content */}
          <h2 className="text-2xl font-bold text-center mb-0 mt-0">
            Allow location
          </h2>
          <p className="text-center mb-6">
            Location is required to win real cash
          </p>
          
          {/* Allow Button */}
          {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
          <Button
            onClick={async () => {
                await refreshLocation(true);
                closeModal();
            }}
            shine
            className='bg-blue text-white w-full h-12 font-bold text-lg rounded-lg'
          >
            Allow
          </Button>
        </div>
      </div>
  );
};